import React, { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import PbrAuthorizer from './components/PbrAuthorizer';

const AgentAssignmentsPage = lazy(() => import('./pages/agent-assignments/agentAssignmentPage'));
const ProficiencyCategoriesPage = lazy(() => import('./pages/proficiency-categories/proficiencyCategoriesPage'));
const ProficienciesPage = lazy(() => import('./pages/proficiencies/proficienciesPage'));
const RoutingRulesPage = lazy(() => import('./pages/routing-rules/RoutingRulesPage'));
const routes: RouteObject[] = [
  {
    element: <PbrAuthorizer />,
    children: [
      {
        path: '/portal/pbr',
        element: <Navigate to='/portal' replace />
      },
      {
        path: '/portal/pbr/categories',
        element: <ProficiencyCategoriesPage />
      },
      {
        path: '/portal/pbr/proficiencies',
        element: <ProficienciesPage />
      },
      {
        path: '/portal/pbr/assignments',
        element: <AgentAssignmentsPage />
      },
      {
        path: '/portal/pbr/routing-rules',
        element: <RoutingRulesPage />
      }
    ]
  }
];

export default routes;
